import { createResourceApi } from 'resources/ResourceApi';
import { CompetitorApiItem } from 'features/Competitor/types';

export default createResourceApi<CompetitorApiItem>('competitors');
